import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DayTripPlanI18nEditDefaultQuery } from "./query";

type Props = {
	hotelID: string;
	planID: string;
	lang: LangCode;
};

export const useDayTripPlanI18nEditQuery = ({ hotelID, planID, lang }: Props) => {
	const { data } = useCustomSuspenseQuery(DayTripPlanI18nEditDefaultQuery, {
		variables: { hotelID, planId: planID, lang },
		fetchPolicy: "no-cache",
	});

	return data;
};
